/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import pick from 'lodash/pick';

/**
 * Pomocná třídá pro práci se stromovou strukturou organizací vrácenou ze serveru.
 */
class OrganizationHelper {
  /**
   * Převede stromovou strukturu organizací na plochý seznam.
   * @param {Object} organization Kořenová organizace, ve formátu, který poslal server.
   * @returns {Array.<Organization>} Seznam organizací v pořadí preorder.
   */
  flatten(organization) {
    const { child = [] } = organization;
    return child.reduce(
      (orgArray, childOrganization) =>
        orgArray.concat(this.flatten(childOrganization)),
      [pick(organization, 'id', 'name')]
    );
  }
}

export default OrganizationHelper;
